export default function Door() {
  return (
    <div
      className="axa-icon-icon-door"
      dangerouslySetInnerHTML={{
        __html: `
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="43px" height="64px" viewBox="0 0 43 64" enable-background="new 0 0 43 64" xml:space="preserve">  <image id="image0" width="43" height="64" x="0" y="0"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAABACAMAAAC0sH5rAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
              AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAXVBMVEUAAAAYGBgdHRocHBod
              HRscHBsdHRocHBobGxsdHRodHRodHRscHBgcHBscHBscHBobGxkbGxscHBsQEBAcHBgbGxscHBoc
              HBodHRsdHRodHRocHBkAAAAdHRv///+p3WYKAAAAHXRSTlMAIE9/j7+frzBQ3/BA0MCAcGCQED9f
              4M/voLBvBB7K9iUAAAABYktHRB5yCiArAAAAB3RJTUUH5gkGDS0a8SJfVAAAAf9JREFUSMfVltuW
              oyAQRaEz2hIVYrC1sYf//82piyhEWNGZpzkvIbq5VZ1ChEglP26/KtJtVV15/9mIgxQ8z+p+QOsC
              2Xrf5dFea8N6dCghjPePFDUIanVcGb4xyYMG0UGIM2xVREUH88X/B0Cf4hx7h+3ac6zy217liCn4
              GlEybCVmYbUTd5qT0H7f8CE0klm82gKXSL2ybp1lRTVpovbywkrPWcThW7cZxVJXaLQRG4aFkabE
              UooH0bsh7De3IcatTMPVU3gi9rEP+5o5QxmK2Dsz6iU9exp2FpgWf3XGEBZCLMRzM49jJ8i1SyoK
              xG402BluHjq7Izvh9BsLS+jXYGRKUCfswo0hOCKVw6Bt7BrcPm91woIpG05jkx82ZddEuEIFDeie
              wDpaC+wsXxaEBXYmi5pStSWsp1BBGH/Gr/UIGyPViHH2yLqCHFqUC2bveP9DGUWbMhv8aDsT66mD
              jAyuKG/q6KDjWfXP7BTK7gSrA1s4HVUFrpqr6sdGbJdFn/s51bxhbRTh5Q3bXGDxRUhcWMNcYq3R
              Gmql1U5SnQ0U5TybiLPwH7LyAvseRdZdYPVZVl1goYLnC6w/y4q/Ye0FVl1g5wusr9+ugr9nPVVq
              /TEy34xZd9DJmrlcJNcSvlt6vjjZxZ8SfyHkwMfowmdonyWXE8YFWWt/U+MPBMZenXSHKIsAAAAl
              dEVYdGRhdGU6Y3JlYXRlADIwMjItMDktMDZUMTM6NDU6MjYrMDA6MDD43lxyAAAAJXRFWHRkYXRl
              Om1vZGlmeQAyMDIyLTA5LTA2VDEzOjQ1OjI2KzAwOjAwiYPkzgAAACh0RVh0ZGF0ZTp0aW1lc3Rh
              bXAAMjAyMi0wOS0wNlQxMzo0NToyNiswMDowMN6WxREAAAAASUVORK5CYII=" />
          </svg>
        `,
      }}
    />
  )
}
